import React, { Fragment } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import BookingForm from "./BookingForm";

const NewBookingModal = ({
  open,
  onClose,
  bookingDate,
  bookingTime,
  service,
  resources,
  discountCodes,
  onSubmit,
  source,
  resourceType,
}) => {

  return (
    <Fragment>
      <Modal isOpen={open} toggle={onClose} size="xl">
        <ModalHeader toggle={onClose} className="bg-light">
          NEW BOOKING
        </ModalHeader>
        <ModalBody>
          <BookingForm
            bookingDate={bookingDate}
            bookingTime={bookingTime}
            service={service}
            resources={resources}
            discountCodes={discountCodes}
            onSubmit={onSubmit}
            newSource={source}
            resourceType={resourceType}
          />
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default NewBookingModal;
